import immutable from 'immutable'
import config from "@/config";


const defaultState = immutable.fromJS({
    tenant : config.CX_NAME
})

export const tenantReducer = (state = defaultState,action) =>{
    return state
}
